import {useContext, useEffect, useState} from 'react'
import {getLocal} from '../../../../hooks/useStorage/useStorage.jsx'
import {
    DirectionsWalkRounded as DirectionsWalkIcon,
    MopedRounded as MopedIcon,
    CheckCircleRounded as CheckCircleIcon
} from '@mui/icons-material'
import {address as textsAddress} from '../../../../translate/Translate.jsx'
import {AddressContext} from '../../../../context/AddressContext.jsx'

import Tour from 'reactour'

import './optionsDelivery.scss'

const steps_tour = [
    {
        selector: '.options-delivery',
        content: textsAddress.chooseDeliveryTakeaway,
        style: {
            borderRadius: 20
        }
    }
]

const OptionsDelivery = ({onClick}) => {
    const {deliveryMode} = useContext(AddressContext)
    const [isVisibleDelevery, setVisibleDelevery] = useState(true)
    const [isVisibleTakeaway, setVisibleTakeaway] = useState(true)
    const [tour, setTour] = useState({
        open: false,
        step: 0
    })

    const checkModules = () => {
        const modules = getLocal('modules')
        const scheduled = getLocal('scheduled', false)
        const scheduledday = getLocal('scheduledday', false)
        const openDelivery = getLocal('openDelivery', false)
        const openTakeWay = getLocal('openTakeWay', false)
        setVisibleDelevery(openDelivery || (modules !== 2 && (scheduled || scheduledday)))
        setVisibleTakeaway(openTakeWay || ((modules === 0 || modules === 2) && scheduled) || (modules === 4 && scheduledday && openTakeWay))
    }

    const checkDeliveryMode = () => {
        const modules = getLocal('modules')
        if (modules === 0 || modules === 4) {
            setTimeout(() => {
                const takeawayOptions = getLocal('takeawayOptions')
                const address = getLocal('address', '')
                const deliveryMode = getLocal('deliveryMode', '')
                if (!takeawayOptions && !address && !deliveryMode) {
                    setTour({...tour, open: true})
                }
            }, 400)
        }
    }

    const handleClose = () => setTour({...tour, open: false})

    useEffect(() => {
        checkModules()
        checkDeliveryMode()
    }, [])


    const handleClickOption = mode => {
        handleClose()
        onClick(mode)
    }
    return <div className={'options-delivery'}>
        {(isVisibleDelevery) && <div
            className={'div-option-delivery'}
            id={(deliveryMode === 'delivery') ? 'option-selected-delivery' : ''}
            onClick={() => handleClickOption('delivery')}>
            <div className={'div-left'}>
                <MopedIcon className={'icon-option-delivery'}/>
                <label className={'label-option'}>
                    {textsAddress.delivery}
                </label>
            </div>
            <CheckCircleIcon
                className={'icon-select-option'}
                id={(deliveryMode === 'delivery') ? 'icon-selected-delivery' : ''}/>
        </div>}
        {(isVisibleTakeaway) && <div
            className={'div-option-delivery'}
            id={(deliveryMode === 'takeaway') ? 'option-selected-delivery' : ''}
            onClick={() => handleClickOption('takeaway')}>
            <div className={'div-left'}>
                <DirectionsWalkIcon className={'icon-option-delivery'}/>
                <label className={'label-option'}>
                    {textsAddress.takeaway}
                </label>
            </div>
            <CheckCircleIcon
                className={'icon-select-option'}
                id={(deliveryMode === 'takeaway') ? 'icon-selected-delivery' : ''}/>
        </div>}
        <Tour
            isOpen={tour.open}
            steps={steps_tour}
            goToStep={tour.step}
            onRequestClose={() => {
                console.log('Escolhe um imbecil')
                setTour({...tour, open: false})
            }}
            disableFocusLock={true}
            showCloseButton={false}
            showNumber={false}
            showButtons={false}
            showNavigation={false}
        />
    </div>
}

export default OptionsDelivery
